
let _toutiao = {

    //加载基础代码
    load: function(){
        let js = '(function(r, d, s) {\n' +
            '        r._tt_config = true;\n' +
            '        var _baq = (r._baq = r._baq || []);\n' +
            '        _baq.methods = ["track", "off", "on"];\n' +
            '        _baq.factory = function(method) {\n' +
            '            return function() {\n' +
            '                var args = Array.prototype.slice.call(arguments);\n' +
            '                args.unshift(method);\n' +
            '                _baq.push(args);\n' +
            '                return _baq\n' +
            '            }\n' +
            '        };\n' +
            '        for (var i = 0; i < _baq.methods.length; i++) {\n' +
            '            var key = _baq.methods[i];\n' +
            '            _baq[key] = _baq.factory(key)\n' +
            '        }\n' +
            '        _baq.load = function() {\n' +
            '            var js, fjs = d.getElementsByTagName(s)[0];\n' +
            '            js = d.createElement(s);\n' +
            '            js.src = "https://analytics.oceanengine.com/api/v2/js/sdk";\n' +
            '            fjs.parentNode.insertBefore(js, fjs)\n' +
            '        };\n' +
            '        _baq.load();\n' +
            '        if (_baq.invoked) {\n' +
            '            return\n' +
            '        }\n' +
            '        _baq.invoked = true;\n' +
            '        _baq.track("pageview")\n' +
            '    })(window, document, "script");';

        let _head = document.getElementsByTagName("head")[0];
        let script = document.createElement("script");
        script.append(js);
        _head.appendChild(script);
    },

    //加载事件代码 - 事件资产ID
    submit: function (assets_id) {
        try {
            console.log(222, '头条')
            _baq.track("form", { assets_id: assets_id + '', product_name: '报名', product_price: 100 })
            console.log(333, '头条头条头条')
        } catch (e) {
            console.log(e)
        }
    },
};

export default _toutiao
